/**
 *
 * @class Subdivision
 *
 * @brief holder for a subdivision and its timelines; the database moy have more than one
 * set of panoramas for a given subdivision.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      July 2022
 *
 */

import {Logger} from "@/util/logger";

export class Subdivision {

  /** subdivision name */
  public name: string        = '';

  /** the paren corridor label */
  public corridor: string    = '';

  /** the timeliens for this subdivision */
  public timelines: string[] = [];

  /** standard constructor */
  public constructor (init?: Partial<Subdivision>) {

    Object.assign(this, init);
  }

  /** add a year/month but only if we don't already have it */
  public addYearMonth(ym: string) {

    if (!/^\d\d\d\d-\d\d-\d\d$/.test(ym.trim())) {

      Logger.error(`[Subdivision] invalid year month: `, ym)
      return ;
    }

    ym = ym.trim();

    /* only add if we don't already have it */

    if (this.timelines.findIndex(x => x == ym) > -1) {

      /* it's already here */

      return true;
    }

    this.timelines.push(ym);

    /* always keep most recent year/month at the top */

    this.timelines.sort((a: string, b: string) => {

      let da: number = Date.parse(a);
      let db: number = Date.parse(b);

      return da - db;
    });

    return true;
  }
}
